import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/chenxiaole/learnTrain/le-react/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "安装"
    }}>{`安装`}</h3>
    <p>{`打开终端运行下列命令：`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`npm install le-react-ui
// 或者
yarn add le-react-ui
`}</code></pre>
    <h3 {...{
      "id": "引入组件"
    }}>{`引入组件`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Button, Switch, Radio } from "le-react-ui"
import "../node_modules/le-react-ui/dist/lib/leReactUI.css"
`}</code></pre>
    <h3 {...{
      "id": "使用"
    }}>{`使用`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`function App() {
  return (
    <div className="App">
        <Button>测试</Button>
    </div>
  );
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      